import { number, object, string } from "yup";
import { FormField } from "./types";
import { useValidationSchema as useMerchantValidationSchema } from "../Merchant";

const useValidationSchema = () =>
    useMerchantValidationSchema()
        .concat(
            object().shape({
                [FormField.Groups]: number()
                    .required()
                    .label('Groups'),
                [FormField.Website]: string()
                    .matches(/^(https?:\/\/|www\.)\S+\.\S+$/, 'Invalid URL')
                    .optional()
                    .label('Website'),
                [FormField.Currency]: string()
                    .optional()
                    .label('Currency')
            })
        );

export default useValidationSchema;
